import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PrimaryButton } from "@/components/admin/ui";
import { api, errMsg } from "@/lib/api";

export default function MarkPaidDialog({ student, onClose, onDone }) {
  const [reference, setReference] = useState("");
  const [amount, setAmount] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/admin/students/${student.id}/mark-paid`, { reference, amount_inr: amount === "" ? null : Number(amount) });
      toast.success(`${student.name} marked as paid`);
      onClose();
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!student} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white rounded-2xl sm:max-w-md" data-testid="mark-paid-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Mark as paid (offline)</DialogTitle>
          <DialogDescription>Record an offline payment for {student?.name}. This unlocks the assessment once consent is on record.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2"><Label>Payment reference</Label><Input required minLength={2} value={reference} onChange={(e) => setReference(e.target.value)} placeholder="e.g. Cash receipt #1024 / UPI ref" data-testid="mark-paid-reference-input" /></div>
          <div className="space-y-2"><Label>Amount received in Rs. (leave blank for current price)</Label><Input type="number" min={0} value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="mark-paid-amount-input" /></div>
          <PrimaryButton type="submit" busy={busy} className="w-full" data-testid="mark-paid-submit">Confirm payment</PrimaryButton>
        </form>
      </DialogContent>
    </Dialog>
  );
}
